<template>
  <div class="onboarding">
    <img src="@/assets/ffbb_hoz_blanc.png" style="width: 128px;height: 51px;" />
    <div class="onboarding-text mt-4 mb-3">
      <span>{{ "preinscription_onboarding_text_1" | translate(locale) }}</span
      ><br />
      <span>{{ "preinscription_onboarding_text_2" | translate(locale) }}</span>
    </div>

    <!-- <div class="onboarding-text mb-5" style="color: red;">
      <span>{{ "preinscription_onboarding_alert" | translate(locale) }}</span>
    </div> -->

    <div v-if="captchaInfo !== undefined" class="divDateNaissance control mb-3">
      <p class="captcha-instructions mr-2 ml-2">
        <span
          v-html="
            $options.filters.translate(
              'preinscription_onboarding_date_naissance',
              locale
            )
          "
        ></span>
      </p>
      <datepicker
        :language="fr"
        input-class="vue-date-picker"
        format="dd/MM/yyyy"
        :typeable="true"
        placeholder="JJ/MM/AAAA"
        v-model="dateNaissance"
      ></datepicker>
    </div>

    <div
      v-if="captchaInfo !== undefined && instructionsCaptcha !== undefined"
      class="captcha-container"
    >
      <p class="captcha-instructions ml-2 mr-2">
        {{ instructionsCaptcha.data }}
      </p>

      <div
        v-for="(captchaImg, index) in captchaInfo.data"
        :key="index"
        class="grid-img"
      >
        <img
          :src="'data:image/jpg;base64,' + captchaImg.data"
          class="captcha-img"
          @click="onCaptcha(captchaImg.code)"
        />
        <img
          v-if="captchaList.includes(captchaImg.code)"
          :src="require('@/assets/white-check.png')"
          class="img-overlay"
        />
      </div>
    </div>

    <div v-if="token_out !== undefined && token_out !== null" class="mt-3 mb-3">
      <b-button variant="outline-primary" @click="validationOnBoarding()"
        >J'Y VAIS</b-button
      >
    </div>
    <div v-if="showErrorMessage()" class="onboarding-error-msg">
      <span>{{
        "preinscription_onboarding_error_msg" | translate(locale)
      }}</span>
    </div>

    <div
      v-if="erreurGlobale != null"
      class="alert alert-danger text-left global-errors ml-5 mr-5 mt-5"
    >
      <p>
        {{ erreurGlobale }}
      </p>
    </div>
  </div>
</template>

<script>
import translations from "@/Translations.js";
import preinscriptionAppelsServeur from "@/preinscriptionUtils";
import Datepicker from "@/components/extensions/datepicker/components/Datepicker";
import { fr } from "@/components/extensions/datepicker/locale";
import _ from "lodash";

export default {
  components: {
    Datepicker
  },
  props: {
    token: undefined,
    captchaInfo: undefined,
    instructionsCaptcha: undefined,
    serverError: null,
    locale: {
      type: String,
      default: "fr"
    }
  },
  data() {
    return {
      erreurGlobale: null, // valorisée dans traitementErreursServeur,
      captchaList: [],
      dateNaissance: "",
      fr: fr,
      token_out: undefined
    };
  },
  filters: {
    translate: function(value, locale) {
      return translations[locale][value];
    }
  },
  watch: {
    token: function() {
      if (this.token) {
        this.token_out = JSON.parse(JSON.stringify(this.token));
      }
    }
  },
  methods: {
    validationOnBoarding() {
      // si le captcha n'est pas present, la validation n'est pas necessaire
      if (!this.captchaInfo && !this.instructionsCaptcha) {
        this.getPreinscription(false /*isReconnected*/);
        return;
      }

      if (this.captchaList.length != 2) {
        this.erreurGlobale =
          "Veuillez cliquer sur les 2 images qui sont décrites plus haut";
        return;
      }
      if (this.dateNaissance === "") {
        this.erreurGlobale =
          "Veuillez fournir la date de naissance associée à cette préinscription";
        return;
      }

      this.getPreinscription(false /*isReconnected*/);
    },
    getPreinscription(isReconnected) {
      var that = this;
      preinscriptionAppelsServeur
        .getPreinscription(
          this.token_out,
          preinscriptionAppelsServeur.formatDateOnBoarding(this.dateNaissance),
          _.join(this.captchaList, ";")
        )
        .then(result => {
          preinscriptionAppelsServeur
            .postEtape(that.token_out, "1", "", false, result.data)
            .then(resultPost => {
              result.data = resultPost;
              this.$emit("getPreinscriptionEmit", result);
            })
            .catch(error => {
              // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
              var argsArray = [];
              preinscriptionAppelsServeur.traitementErreursServeur(
                error,
                isReconnected,
                that,
                that.getPreinscription,
                argsArray
              );
            });
        })
        .catch(error => {
          // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
          var argsArray = [];
          preinscriptionAppelsServeur.traitementErreursServeur(
            error,
            isReconnected,
            that,
            that.getPreinscription,
            argsArray
          );
        });
    },
    showErrorMessage() {
      if (this.serverError != null) {
        this.erreurGlobale = this.serverError;
      }
      return this.token_out === null;
    },
    onCaptcha(captchaImgCode) {
      if (this.captchaList.includes(captchaImgCode)) {
        this.captchaList = _.remove(this.captchaList, function(code) {
          return code != captchaImgCode;
        });
      } else if (this.captchaList.length < 2) {
        this.captchaList.push(captchaImgCode);
      }
    }
  },
  created() {
    // la clone token_out est utilisée pour pouvoir mettre a jour le token si la session a expiré (on peut pas modifier directement un prop)
    if (this.token) {
      this.token_out = JSON.parse(JSON.stringify(this.token));
    }
  }
};
</script>

<style>
html,
body {
  margin: 0;
  height: 100%;
}
body {
  display: table;
  width: 100%;
}

.app {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

body {
  background: url("~@/assets/image_pre_home.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}

html {
  background: url("~@/assets/image_pre_home.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 100%;
}

.btn-outline-primary {
  color: #ffffff !important;
  border-color: #ffffff !important;
  width: 284px;
  height: 45px;
  border-radius: 22.5px !important;
}

.onboarding-text,
.onboarding-error-msg {
  font-family: Lato;
  font-size: 26px;
  font-weight: bold;
  color: #ffffff;
}

.captcha-container {
  width: 400px;
  background: #ffffff00;
  display: inline-block;
}

.captcha-img {
  width: 122px;
  height: 122px;
  cursor: pointer;
}

.captcha-img:hover {
  border: 1px solid #ffffff;
}

.grid-img {
  padding: 5px;
  display: inline-grid;
  position: relative;
}

.grid-img .img-overlay {
  width: 30px;
  height: 30px;
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.divDateNaissance {
  text-align: -webkit-center;
}
@-moz-document url-prefix() {
  .divDateNaissance {
    text-align: -moz-center;
  }
}

.captcha-instructions {
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  color: #fff;
}

.captcha-checked {
  opacity: 0.5;
  background-color: #008cba;
}

.onboarding label,
.onboarding input {
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  color: #fff;
  cursor: pointer;
}

.onboarding .vdp-datepicker {
  width: 225px;
  margin-top: 10px;
}

.onboarding .vue-date-picker {
  background: transparent;
  border: 1px solid #ffffff;
  text-align: center;
}

@media (max-width: 400px) {
  .captcha-container {
    width: 100%;
  }

  .grid-img {
    width: 30%;
    height: 30%;
  }

  .captcha-img {
    width: 100%;
  }
}
</style>
